// extracted by mini-css-extract-plugin
export default {"wrapper":"SurveyAssetsAndProperty_wrapper__97pXa"};